var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"xiaodianfragment",staticStyle:{"width":"100%","height":"calc(100vh - 50px)","overflow":"hidden"}},[_c('div',[_c('hint'),_vm._v(" "),_c('question-list',{attrs:{"Datalist":_vm.datalist,"scroll":_vm.scroll},on:{"scrollto":_vm.ScrollTo}}),_vm._v(" "),_c('xiaodian-charge',{staticClass:"struction_style"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187acce3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeilingXiaoDian.vue
// module id = null
// module chunks = 